export const projects = [
  {
    title: "Triceracops",
    subtitle: "React, JSX, Bootstrap",
    description:
      "a murder-mystery escape room style game, final project at Makers",
    image: "./triceracops.gif",
    link: "https://github.com/jooomin/tricera-cops",
  },
  {
    title: "AceBook",
    subtitle: "Ruby on Rails, PostgreSQL, Rspec, CSS",
    description:
      "a full-stack web app imitating the basic functions of Facebook",
    image: "./acebook.gif",
    link: "https://github.com/jooomin/acebook-smells-like-team-spirit",
  },
  {
    title: "Notes App",
    subtitle: "Javascript, HTML, CSS",
    description:
      "a web app for taking notes",
    image: "./notesapp.gif",
    link: "https://github.com/jooomin/notes_app",
  },
  {
    title: "Weather App",
    subtitle: "Next.js, SCSS",
    description:
      "a web app for checking weather conditions in different locations",
    image: "./weatherapp.gif",
    link: "https://github.com/jooomin/weather-app-next.js",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "Ruby",
  "JavaScript",
  "SQL",
  "HTML",
  "CSS",
  "Ruby on Rails",
  "React",
  "Next.js",
  "RSpec",
  "Jasmine",
  "Sinatra",
  "PostgreSQL"
];



// WEBPACK FOOTER //
// ./src/data.js